/**
 * Subscription modal
 */

export function subscriptionMemberModal() {
	if (jQuery("#memberOverviewModal").length == 0) {
		return;
	}
	var memberkey = "";
	var remove = false;
	jQuery('#memberOverviewModal').validator();

	// - Prevent pop-up if form is invalid
	jQuery(document).on("click", ".js-bookmark", function (e) {
		e.preventDefault();
		var email = Cookies.get('member-overview');
		// Remove er omvendt da active klassen sættes før click eventet trigges, så hvis den ikke har active klassen betyder det at den skal fjernes.
		remove = jQuery(this).hasClass("active") ? false : true;
		
		memberkey = jQuery(this).data("member-key");
		console.log(remove)
		console.log(email)
		if (email != undefined && email != "") {
			saveMember(email)
		} else {
			jQuery('#memberOverviewModal').modal("show");
		}
	});

	var selectedMembers = $(".member-overview").data("selectedmembers");
	if (selectedMembers) {
		selectedMembers = selectedMembers.split(",");
		selectedMembers.forEach(function (member) {
			console.log(member);
			jQuery(".js-bookmark[data-member-key='" + member + "']").toggleClass("active");
		});
	}	


	jQuery(document).on('input', '#memberOverviewModal #signupEmail', function () {
		var email = jQuery('#memberSubscriptionForm #signupEmail').val();
		jQuery('#memberSubscriptionForm .btn__submit').prop('disabled', true);
		if (isValidEmail(email)) {
			//enable the submit button
			jQuery('#memberSubscriptionForm .btn__submit').prop('disabled', false);
		} else {
			//disable the submit button
			jQuery('#memberSubscriptionForm .btn__submit').prop('disabled', true);
		}
	}),
		// - Change modal view when send btn is clicked
		jQuery(document).on("click", "#submitMemberSubscription", function (e) {
			e.preventDefault()
			var email = jQuery("#memberSubscriptionForm #signupEmail").val();
			saveMember(email)
		});

	async function saveMember(email) {
		var form = jQuery("#memberSubscriptionForm");
		console.log({
					email: email,
					lang: document.documentElement.getAttribute('lang'),
					memberPageId: form.data("memberpageid"),
					memberKey: memberkey,
					remove: remove
				})
		try {
			const response = await fetch("/api/Subscribe/SubscribeToMember", {
				method: "POST",
				headers: {
					"Content-Type": "application/json"
				},
				body: JSON.stringify({
					email: email,
					lang: document.documentElement.getAttribute('lang'),
					memberPageId: form.data("memberpageid"),
					memberKey: memberkey,
					remove: remove
				})
			});

			if (!response.ok) {
				throw new Error("HTTP error " + response.status);
			}

			const data = await response.json();
			SetEmailCookie(email);
			setMemberKeyCookie();
			showMessage(data);
		} catch (error) {
			console.log("Error:", error);
			showMessage(false);
		}
	}
	//Set member key cookie in list for future use, e.g. to check if user is already a member when visiting another page with the subscription modal
	function setMemberKeyCookie() {
		var storedMemberKeys = Cookies.get('member-key');
		if (storedMemberKeys) {
			storedMemberKeys = storedMemberKeys.split(',');
			if (!storedMemberKeys.includes(memberkey)) {
				storedMemberKeys.push(memberkey);
			}
			Cookies.set('member-key', storedMemberKeys.join(','));
		} 
		memberkey = "";
	}
	function SetEmailCookie(email) {
		let url = window.location.pathname;
		let path = url.substring(0, url.lastIndexOf('/'));
		console.log(Cookies)
		Cookies.set('member-overview', email, { path: path });
	}
	//TODO UMB9 Success with small s !!
	function showMessage(response, areas) { // - If success
		var form = jQuery("#memberSubscriptionForm").parent().parent();
		if ((response.success && response.isNew) || (response.success && !response.isApproved)) {

			form.find(".message-body__error").hide();
			form.find(".message-body__isMember").hide();
			form.find(".message-body__conformation").show();
		} else if (response.success && response.isApproved) {

			form.find(".message-body__error").hide();
			form.find(".message-body__conformation").hide();
			form.find(".message-body__isMember").show();
		} else {
			form.find(".message-body__isMember").hide();
			form.find(".message-body__conformation").hide();
			form.find(".message-body__error").show();
			// - Run animate function
		}
		animate();
	}

	// - Animate modal slide
	function animate() {
		jQuery('.modal-content').animate({
			height: jQuery('.modal-content').outerHeight()
		}, 600);

		jQuery('.message-body').removeClass("modal-body__hidden");

		jQuery('.subscription-body').animate({
			"margin-top": "-" + jQuery('.subscription-body').outerHeight() + "px"
		}, 600, function () {
			jQuery('.subscription-body').addClass("modal-body__hidden")
		});
	}

	// Close modal when close btns are clicked
	jQuery("button.close").on("click", function () {
		setTimeout(function () {
			jQuery('.subscription-body').css("margin-top", "0px");
			jQuery('.subscription-body').removeClass("modal-body__hidden");
			jQuery('.message-body').addClass("modal-body__hidden")
		}, 1000);
	});

	// Return to previous modal when error btn is clicked
	jQuery(".message-body__error button").on("click", function () {
		jQuery('.modal-content').animate({
			height: jQuery('.modal-content').outerHeight()
		}, 600);

		jQuery('.subscription-body').removeClass("modal-body__hidden");

		jQuery('.subscription-body').animate({
			"margin-top": "0px"
		}, 600, function () {
			jQuery('.message-body.error').addClass("modal-body__hidden")
		});
	});

	jQuery(document).on('input', '#emailInput', function () {
		validateForm();
	})
	function validateForm() {
		var email = jQuery('#memberSubscriptionForm #emailInput').val();
		jQuery('.btn__submit').prop('disabled', true);
		if (isValidEmail(email) && jQuery('#consent').is(':checked')) {
			//enable the submit button
			jQuery('.btn__submit').prop('disabled', false);
		} else {
			//disable the submit button
			jQuery('.btn__submit').prop('disabled', true);
			//turn off hover effects
		}
	}
	function isValidEmail(email) {
		const emailRegex = /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
		return emailRegex.test(email);
	}
}

export default subscriptionMemberModal;
